import * as z from "zod/v4";

export const LocationInputSchema = z.object({
  name: z.string(),
  address1: z.string(),
  address2: z.string(),
  city: z.string(),
  province: z.string(),
  zip: z.string(),
  countryCode: z.string(),
  phone: z.string(),
  company: z.string(),
});

export type LocationInput = z.infer<typeof LocationInputSchema>;

export const addLocation = {
  name: "addLocation" as const,
  input: LocationInputSchema,
  output: z.union([
    z.object({ success: z.literal(true) }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
